import { API, graphqlOperation } from 'aws-amplify';

export default {
    namespaced: true,
    state: {
        tags: [],
        visitorsCache: {}
    },
    mutations: {
        tags: (state, payload) => { state.tags = payload.value },
        loadVisitors: (state, payload) => { state.visitorsCache = Object.assign(state.visitorsCache, payload)},
    },
    actions: {

        async listTags(context, payload) {
            console.debug('Store loading tags...');
            if(!payload.domainID) {
              console.error('Domain is not provided in payload')
              return;
            }
            const t = await API.graphql(graphqlOperation(/* GraphQL */ `query GetDomain($id: ID!) {
              getDomain(id: $id) {
                tags(limit: 1000) {
                  items {
                    id
                    name
                  }
                  nextToken
                }
              }
            }`, { id: payload.domainID }));
            
            if(t.data.getDomain.tags.nextToken) {
              console.warn('Not all tags are loaded!');
            }
            console.debug('tags response', t);
            const isSelected = (t) => {
              if(Array.isArray(payload.selected)) {
                return !!payload.selected.find(s => s.id == t.id);
              } else {
                return payload.selected == t.id;
              }
            };
            let items = t.data.getDomain.tags.items.map(t => ({...t, selected: isSelected(t) }));
            
            context.commit('tags', {value: items });
        },

        async loadVisitors(context, payload) {
            const q = await API.graphql(graphqlOperation(`
              query GetTag($id: ID!) {
                getTag(id: $id) {
                    id
                    visitorCount
                }
              }
              `, { id: payload.id }));
              let r = q.data.getTag;
              context.commit('loadVisitors', { [r.id]: r.visitorCount });
        },
    }
}